module.exports = __webpack_public_path__ + "img/iphone-15.e19eee1f.svg";